export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SET_USER_ID = "SET_USER_ID";
export const SET_PORTAL = "SET_PORTAL";
